import {Injectable} from '@angular/core';
import {GuardService} from "../services/guard.service";
import {FormService} from "../services/form.service";

@Injectable()
export class FormChangesGuard {

  constructor(private guardService: GuardService,
              private formService: FormService) {
  }

  async canDeactivate() {
    // console.log('getForceSkipCheck', this.formService.getForceSkipCheck());
    // if (this.formService.getForceSkipCheck()) return true;
    const result = await this.guardService.skipChanges();
    if (result)
      this.formService.setActiveForms([]);
    return result;
  }
}
